import { BlockOverrides } from 'baseui/block';
import { THEME } from '@lyon/utils/theme';

const blockStyles = {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridColumnGap: '16px',
  gridRowGap: '40px',
  alignItems: 'start',
  alignContent: 'start',

  [THEME.media.large]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
};

export const BLOCK: BlockOverrides = {
  Block: {
    style: {
      ...blockStyles,

      [THEME.media.xxxlarge]: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
      [THEME.media.xxlarge]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
    },
  },
};

export const HOME_BLOCK: BlockOverrides = {
  Block: {
    style: {
      ...blockStyles,

      [THEME.media.xxlarge]: {
        gridTemplateColumns: 'repeat(4, 1fr)',
      },
      [THEME.media.xlarge]: {
        gridTemplateColumns: 'repeat(3, 1fr)',
      },
    },
  },
};

export const ROW_BLOCK: BlockOverrides = {
  Block: {
    style: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr',
      gridRowGap: '24px',
    },
  },
};
